/* eslint-disable */
/**
 * ES6 polyfill for new array methods
 * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array
 */
;(function(universal) {
    /**
     * Object methods
     */

    /**
     * Array.from
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/from
     */
    if (!universal.Array.from) {
        universal.Array.from = (function() {
            var toStr = Object.prototype.toString;
            var isCallable = function(fn) {
                return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
            };
            var toInteger = function(value) {
                var number = Number(value);
                if (isNaN(number)) {
                    return 0;
                }
                if (number === 0 || !isFinite(number)) {
                    return number;
                }
                return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
            };
            var maxSafeInteger = Math.pow(2, 53) - 1;
            var toLength = function(value) {
                var len = toInteger(value);
                return Math.min(Math.max(len, 0), maxSafeInteger);
            };

            return function from(arrayLike/*, mapFn, thisArg */) {
                var C = this;
                var items = Object(arrayLike);

                if (arrayLike == null) {
                    throw new TypeError("Array.from requires an array-like object - not null or undefined");
                }

                var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                var T;

                if (typeof mapFn !== 'undefined') {
                    if (!isCallable(mapFn)) {
                        throw new TypeError('Array.from: when provided, the second argument must be a function');
                    }

                    if (arguments.length > 2) {
                        T = arguments[2];
                    }
                }

                var len = toLength(items.length);
                var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                var k = 0;
                var kValue;

                while (k < len) {
                    kValue = items[k];
                    if (mapFn) {
                        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                    } else {
                        A[k] = kValue;
                    }
                    k += 1;
                }

                A.length = len;

                return A;
            };
        }());
    }

    /**
     * Array.of
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/of
     */
    if (!universal.Array.of) {
        universal.Array.of = function() {
            return Array.prototype.slice.call(arguments);
        };
    }

    /**
     * Prototype Methods
     */

    /**
     * Array.prototype.find
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/find
     */
    if (!universal.Array.prototype.find) {
        universal.Array.prototype.find = function(predicate) {
            if (this === null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }

    /**
     * Array.prototype.findIndex
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
     */
    if (!universal.Array.prototype.findIndex) {
        universal.Array.prototype.findIndex = function(predicate) {
            if (this === null) {
                throw new TypeError('Array.prototype.findIndex called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return i;
                }
            }
            return -1;
        };
    }

    /**
     * Array.prototype.copyWithin
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/copyWithin
     */
    if (!universal.Array.prototype.copyWithin) {
        universal.Array.prototype.copyWithin = function(target, start/*, end*/) {
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);
            var len = O.length >>> 0;
            var relativeTarget = target >> 0;

            var to = relativeTarget < 0 ?
                Math.max(len + relativeTarget, 0) :
                Math.min(relativeTarget, len);

            var relativeStart = start >> 0;

            var from = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);

            var end = arguments[2];
            var relativeEnd = end === undefined ? len : end >> 0;

            var final = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);

            var count = Math.min(final - from, len - to);

            var direction = 1;

            if (from < to && to < (from + count)) {
                direction = -1;
                from += count - 1;
                to += count - 1;
            }

            while (count > 0) {
                if (from in O) {
                    O[to] = O[from];
                } else {
                    delete O[to];
                }

                from += direction;
                to += direction;
                count--;
            }

            return O;
        };
    }

    /**
     * Array.prototype.fill
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
     */
    if (!universal.Array.prototype.fill) {
        universal.Array.prototype.fill = function(value) {

            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);

            // Steps 3-5.
            var len = O.length >>> 0;

            // Steps 6-7.
            var start = arguments[1];
            var relativeStart = start >> 0;

            // Step 8.
            var k = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);

            // Steps 9-10.
            var end = arguments[2];
            var relativeEnd = end === undefined ?
                len : end >> 0;

            // Step 11.
            var final = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);

            // Step 12.
            while (k < final) {
                O[k] = value;
                k++;
            }

            // Step 13.
            return O;
        };
    }

    /**
     * Array.prototype.includes
     * @link https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
     */
    if (!universal.Array.prototype.includes) {
        universal.Array.prototype.includes = function(searchElement /*, fromIndex*/) {
            'use strict';
            var O = Object(this);
            var len = parseInt(O.length, 10) || 0;
            if (len === 0) {
                return false;
            }
            var n = parseInt(arguments[1], 10) || 0;
            var k;
            if (n >= 0) {
                k = n;
            } else {
                k = len + n;
                if (k < 0) {
                    k = 0;
                }
            }
            var currentElement;
            while (k < len) {
                currentElement = O[k];
                if (searchElement === currentElement ||
                    (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
                    return true;
                }
                k++;
            }
            return false;
        };
    }
})(window || global || {});
/* eslint-enable */



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/polyfills/array-esnext/index.js